"use client";

import { useState } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Brain, Phone, Menu, X } from "lucide-react";

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: "/dich-vu", label: "DỊCH VỤ" },
    { href: "/giai-phap", label: "GIẢI PHÁP" },
    { href: "/san-pham", label: "SẢN PHẨM" },
    { href: "/gioi-thieu", label: "GIỚI THIỆU" },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 lg:px-0">
        {/* Logo */}
        <Link
          href="/"
          className="flex items-center gap-2 hover:opacity-80 transition"
        >
          <div className="flex h-10 w-10 items-center justify-center rounded-lg text-white">
            <img src="https://cdn.machineai.vn/logo_3b5204faf6.png" title="Machine AI"/>
          </div>
          <span className="text-xl font-bold text-slate-900">MachineAI</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-md font-medium text-slate-600 hover:text-primary transition "
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Right Side - Phone & CTA */}
        <div className="hidden md:flex items-center gap-4">
          <div className="flex items-center gap-2 text-slate-600">
            <Phone className="h-4 w-4" />
            <Link href={"tel:0886967375"}>
              <span className="text-sm font-medium">0886-967-375</span>
            </Link>
          </div>
          <Link href="#lien-he">
            <Button className="bg-primary text-white hover:bg-primary/90">
              Tư Vấn Miễn Phí
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? (
            <X className="h-6 w-6 text-slate-900" />
          ) : (
            <Menu className="h-6 w-6 text-slate-900" />
          )}
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="block py-2 text-base font-medium text-slate-600 hover:text-primary transition"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-4 border-t border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 mb-4">
                <Phone className="h-4 w-4" />
                <Link href={"tel:0886967375"}>
                  <span className="text-sm font-medium">0886-967-375</span>
                </Link>
              </div>
              <Link href="/#lien-he">
                <Button className="w-full bg-primary text-white hover:bg-primary/90">
                  Tư Vấn Miễn Phí
                </Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
